import styled from "styled-components";
import {IProductSpecial} from "../../interfaces/IProductSpecial";
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
// @ts-ignore
import Link from 'next/link';
// @ts-ignore
import ReactStars from "react-rating-stars-component";
import TextTruncate from "react-text-truncate";
import Image from "next/legacy/image";
import AddToWishlist from "../wishlist/AddToWishlist";
import AddToCart from "../cart/addToCart";
import {useContext, useState} from "react";
import {getNavPath} from "../../shared/navigateUtil";
import {useRouter} from "next/router";
import Tag from "../Tag";
import {IClickSource} from "../../interfaces/IClickSource";
import {getTheme} from "../../shared/themeUtils";
import {ClientContext} from "../../contexts/ClientContext";

const CarouselContain = styled.div`
  .item {
    padding: 10px;
  }

  .dots {
    .react-multi-carousel-dot button {
      border: 1px solid ${getTheme("colors.border")};
    }

    .react-multi-carousel-dot--active button {
      background: ${getTheme("colors.primary")};
      border: 1px solid ${getTheme("colors.border")};
    }
  }
`

const CarouselEntry = styled.div`
  z-index: 1;
  position: relative;
  
  .hover-actions {
    z-index: 10;
    position: absolute;
    top: ${getTheme("space.0")};
    right: ${getTheme("space.0")};
    display: flex;
    justify-content: center;
    opacity: .8;
    flex-direction: column;
  }

  .top {
    height: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${getTheme("colors.border")};
    border-radius: ${getTheme("borderRadius")};
    position: relative;
    cursor: pointer;
    
    .img-contain {
      transition: transform .3s ease-in-out;
    }

    &:hover {
      .img-contain {
        transform: scale(1.1);
      }
    }
    
  }

  .bottom {
    margin-top: ${getTheme("space.2")};
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    cursor: pointer;

    .rating {
      display: flex;
      align-items: center;
      margin-bottom: ${getTheme("space.0")};

      .reviews-count {
        color: ${getTheme("colors.secondaryFont")};
        font-size: ${getTheme("fontSizes.small")};
        position: relative;
        top: 2px;
        left: 8px;
      }
    }

    .price {
      font-weight: bold;
      font-size: ${getTheme("fontSizes.large")};

      .old-price {
        font-weight: normal;
        font-size: ${getTheme("fontSizes.small")};
        position: relative;
        left: ${getTheme("space.1")};
        color: ${getTheme("colors.secondaryFont")};
      }
    }
  }
`

const ProductCarousel = ({items = [], clickSource} : {items: IProductSpecial[], clickSource?: IClickSource}) => {
  const router = useRouter()
  const [showActions, setShowActions] = useState(false)
  const [hoveredItem, setHoveredItem] = useState()
  const [activePage, setActivePage] = useState(1)
  const {clientCtx} = useContext(ClientContext)

  const handleShowActions = (item: any) => {
    setHoveredItem(item)
    setShowActions(true)
  }

  const handleHideActions = () => {
    setShowActions(false)
  }


  const responsive = {
    xl: {
      breakpoint: {
        min: 1200,
        max: 10000
      },
      items: 5,
      slidesToSlide: 5,
      partialVisibilityGutter: 100
    },
    l: {
      breakpoint: {
        max: 1199,
        min: 900,
      },
      items: 4,
      slidesToSlide: 4
    },
    m: {
      breakpoint: {
        max: 899,
        min: 600,
      },
      items: 3,
      slidesToSlide: 3
    },
    sm: {
      breakpoint: {
        max: 599,
        min: 451,
      },
      items: 2,
      slidesToSlide: 2
    },
    xsm: {
      breakpoint: {
        max: 450,
        min: 0,
      },
      items: 1,
      slidesToSlide: 1
    }
  }


  const handleBeforeChange = (currentSlide: any, nextSlide: any) => {
    const newActivePage = nextSlide + 1;

    if (newActivePage !== activePage) {
      setActivePage(newActivePage);
    }
  }


  const CustomDot = ({onClick, active, totalItems}: any) => {
    const itemsPerPage = responsive.xl.items;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const lineWidth = 100 / totalPages;
    const activeWidth = lineWidth / totalPages;

    return (
      <li
        style={{
          width: `${lineWidth}%`,
          height: '2px',
          background: "#e1e1e1",
          margin: '0',
          padding: '0',
          position: 'relative',
          cursor: 'pointer',
        }}
        onClick={onClick}
      >
        {active && (
          <span
            style={{
              position: 'absolute',
              left: 0,
              width: `${activeWidth * 100}%`,
              height: '8px',
              background: 'black'
            }}
          ></span>
        )}
      </li>
    )
  }


  return (
    <CarouselContain>
        <Carousel
        additionalTransfrom={0}
        arrows
        className="product-carousel"
        containerClass=""
        dotListClass="dots"
        draggable
        focusOnSelect={false}
        itemClass="item"
        keyBoardControl
        ssr={true}
        renderButtonGroupOutside={true}
        renderDotsOutside={false}
        partialVisible={false}
        minimumTouchDrag={80}
        customDot={<CustomDot totalItems={items.length}/>}
        beforeChange={handleBeforeChange}
        infinite={false}
        responsive={responsive}
        showDots={true}
        sliderClass=""
        swipeable
      >
          {items && items.length > 0 && items.map(item => (
            <CarouselEntry key={item.productID} onMouseOver={() => handleShowActions(item.productID)}
                           onMouseOut={handleHideActions}>
              {(showActions && hoveredItem == item.productID) && <div className="hover-actions">
                {clientCtx &&
                  <AddToCart layout={"default"}
                           productId={item.productID}
                           currency={item.currency}
                           name={item.productName}
                           price={item.price}
                           gaCId={clientCtx.gaCId}
                           icon={true}
                           variant={"transparent"}
                           iconSize={"small"}/>
                }
                <AddToWishlist layout={"default"} className="add-to-wishlist" variant="transparent"
                               productId={item.productID} width={"auto"} iconSize={"small"}/>
              </div>}
              {item.customOverlay && item.customOverlay}
              <Link
                href={{
                  pathname: getNavPath(router, `p/${item.slug}`, clickSource)
                }}
                key={item.productID}>
                <div>
                  <div className="top">
                    <Tag productTarget={item} type="product"/>
                    <div className="img-contain">
                      <Image src={item.image.imageUrl} alt={item.productName} width={"120"} height={"120"}
                             objectFit="contain"/>
                    </div>
                  </div>
                  <div className="bottom">
                    {item.hasProductReviews &&
                      <div className="rating">
                        <ReactStars
                          count={5}
                          size={15}
                          activeColor="#ffd700"
                          edit={false}
                          isHalf={true}
                          value={item.overallReviewRating}
                        />
                        <span className="reviews-count">({item.productReviewsCount})</span>
                      </div>
                    }
                    <div className="title">
                      <b>{item.brand} </b>
                      <TextTruncate
                        maxCalculateTimes={0}
                        line={2}
                        element="div"
                        truncateText="…"
                        text={item.productName}
                      />
                    </div>
                    <div className="price">
                      {item.currencyPrice}
                      {item.displayUvp &&
                        <span className="old-price angled-strikethrough">{item.currencyUvp}</span>
                      }
                    </div>
                  </div>
                </div>
              </Link>
            </CarouselEntry>
          )
        )}
      </Carousel>
    </CarouselContain>
  );
}

export default ProductCarousel;
